import React, { useEffect, useState, Suspense } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-blue/theme.css";
import ErrorBoundray from "../components/ErrorBoundray/ErrorBoundray";
import dataServices from "../common/dataServices";

//const ContactUs = React.lazy(() => import("../components/ContactUs/ContactUs"));
//const A = React.lazy(() => import("../components/Footer/Footer"));
import Article from "../components/Article/Article";
import ArticleHome from "../components/Article-Home/ArticleHome";
import ArticleIndustryPage from "../components/ArticleIndustryPage/ArticleIndustryPage";
import CarouselHome from "../components/CarouselHome/CarouselHome";
import AboutUsPage from "../components/AboutUsPage/AboutUsPage";
import ContactUs from "../components/ContactUs/ContactUs";

import ContactUsDetails from "../components/ContactUsDetails/ContactUsDetails";
import Map from "../components/Map/Map";
import Messages from "../components/Messages/Messages";
import NewsLetter from "../components/NewsLetter/NewsLetter";
import Header from "../components/Header/Header";
import NewsLetterTitle from "../components/NewsLetterTitle/NewsLetterTitle"; 
import Footer from "../components/Footer/Footer";
import SearchResults from "../components/Search/SearchResults";
import Video from "../components/Video/Video";


const ModWebParts = (props) => {
  const [items, setItems] = useState(null);
  let type = props.webPartProperties.type;
  let webpartTitle = props.webPartProperties.title;
  let webpartLink = props.webPartProperties.readMoreLink;
  let webpartLinkTitle = props.webPartProperties.readMoreTitle;
  let webpartLayout = props.webPartProperties.layout;
  let freeText = props.webPartProperties.ModText;
  let WpId = props.webPartProperties.WpId;
  let siteUrl = props.webPartProperties.site;
  let loadSPList = props.webPartProperties.LoadSPList === "True";
  useEffect(() => {
    // componentDidMount - GetListItems
    let listName = props.webPartProperties.listName;
    let viewName = props.webPartProperties.listView;
    
    if (loadSPList) {
      dataServices
        .getSPListItems(siteUrl, listName, viewName)
        .then((response) => response.data)
        .then((lsItemsResponse) => {
          try {
            setItems(lsItemsResponse.Data);
          } catch (e) {
            console.log(e);
          }
        });
    }
    else {
      setItems({});
    }
  }, []);


  if (items === null) {
    return null;
  }

  let selectedWP = "";
  switch (type) {
    case "Article":
      if(webpartLayout.toLowerCase()=='first'){      
      selectedWP = (
        <Article
          items={items}
          mainURL={siteUrl}
          siteName={webpartLinkTitle}
          title={webpartTitle}
        />
      );
    }
    
      else if (webpartLayout.toLowerCase()=='second'){
        selectedWP = (
          <ArticleHome
            items={items}
            mainURL={siteUrl}
            siteName={webpartLinkTitle}
            title={webpartTitle}
          />
        );
      }
      else {
        selectedWP = (
          <ArticleIndustryPage
            items={items}
            mainURL={siteUrl}
            siteName={webpartLinkTitle}
            title={webpartTitle}
            freeText={freeText}
          />
        );
      }
      break;
    case "Carousel":
        if(webpartLayout.toLowerCase()=='first'){      
        selectedWP = (
          <CarouselHome
            items={items}
            mainURL={siteUrl}
            siteName={webpartLinkTitle}
            title={webpartTitle}
            freeText ={freeText} >
            </CarouselHome>
                  );
        
        }
        else{
          
          selectedWP = (  <AboutUsPage
              items={items}
              mainURL={siteUrl}
              siteName={webpartLinkTitle}
             // title={webpartTitle}
              //freeText ={freeText}
               >
          </AboutUsPage>);

        }
        break;
    case "ContactUs":
        selectedWP = (
          <ContactUs
            items={items}
            mainURL={siteUrl}
            listName={props.webPartProperties.listName}
            siteName={webpartLinkTitle}
            title={webpartTitle}
            freeText ={freeText} 
            showNote={true}>
          </ContactUs>  );
        break;
    case "ContactUsDetails":
       
        selectedWP = (
          <ContactUsDetails
            items={items}
            mainURL={siteUrl}
            siteName={webpartLinkTitle}
            title={webpartTitle}
          />
        );
        break;
    case "Map":
        selectedWP = (
          <Map
            items={items}
            mainURL={siteUrl}
            siteName={webpartLinkTitle}
            title={webpartTitle}
          />
        );
        break;
    case "Messages":
        selectedWP = (
          <Messages
            items={items}
            mainURL={siteUrl}
            siteName={webpartLinkTitle}
            title={webpartTitle}
          />
        );
        break;
    case "News":
          selectedWP = (
            <NewsLetterTitle
              items={items}
              mainURL={siteUrl}
              siteName={webpartLinkTitle}
              title={webpartTitle}
             
            />
          );
          break;
    case "Footer":
      selectedWP = <Footer items={items}  mainURL={siteUrl} />;
      break;
    case "Register":
        selectedWP = (
          <NewsLetter
            items={items}
            mainURL={siteUrl}
            siteName={webpartLinkTitle}
            title={webpartTitle}
            freeText = {freeText}
          />
        );
        break;
    case "Tabs":
          selectedWP = (
            <Header
              // items={items}
              // mainURL={siteUrl}
              // siteName={webpartLinkTitle}
              // title={webpartTitle}
              // freeText = {freeText}
            />
          );
          break;
    case "SearchResult":
          selectedWP = (
            <SearchResults
              // items={items}
              // mainURL={siteUrl}
              // siteName={webpartLinkTitle}
              // title={webpartTitle}
              // freeText = {freeText}
            />
          );
          break;
          case "Video":
            
            selectedWP = (
              <Video
                title={webpartTitle}
                link={webpartLink}
                items={items}
              />
            );
  default:
      break;
  }

  return (
    <div className={"modWPContainer " + type + "_" + webpartLayout}>

      <ErrorBoundray>
        <Suspense fallback={<h3 role="alert">בטעינה ...</h3>}>
          {selectedWP}
        </Suspense>
      </ErrorBoundray>

    </div>
  );
};
export default ModWebParts;
